
import React, { useState, useEffect } from "react"
import { Box, Card, CardContent, CardHeader, Typography, Button } from "@mui/material"



const UltimasConversaciones = (ConversationData, reloadCount) => {
    const [lastConversations , setLastConversations] = useState([]);

    useEffect(() => {
        var conversationListClean = [];
        ConversationData.ConversationData.forEach((item) => {
            //transform string to date
            const date = new Date(item.horario);
            item.horario = date.toLocaleTimeString('es-ES', { hour12: false });
            conversationListClean.push(item);
        })

        setLastConversations(conversationListClean)
    }, [ConversationData]);

    


    return (
        <Card style={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <CardHeader title="Últimas 5 Conversaciones" />
            <CardContent style={{ flex: 1 }}>
                <Box>
                    {lastConversations.map((item, index) => (
                            <Box key={index} display="flex" justifyContent="space-between" mb={1}>
                                <Typography>{item.numero} ({item.flow.name})</Typography>
                                <Typography>{item.horario}</Typography>
                                <Typography fontWeight="bold" color="primary">
                                    <a href={`/messaging/flow/${item.flow.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                        ir
                                    </a>
                                </Typography>
                            </Box>
                        ))}
                </Box>
            </CardContent>
            <Box display="flex" justifyContent="center" p={2}>
                <Button onClick={() => reloadCount} variant="contained" color="primary">
                    Actualizar
                </Button>
            </Box>
        </Card>
    )
}

export default UltimasConversaciones;